import { combineReducers } from 'redux';
import UserReducer from './UserReducer';
import ShowOtherReducers from './ShowOtherReducers';
import QuestionReducers from './QuestionReducers';

export default combineReducers({
  selectedUser: UserReducer,
  showOtherOption: ShowOtherReducers,
  questionOptions: QuestionReducers
});